import { EventEmitter } from '@angular/core';
import { ATTRIBUTION_MODE_LABELS } from 'SecuritiesApp/ts/features/attribution-factor-analysis/attribution-bar-chart-constants';
import { AttributionMode } from 'SecuritiesApp/ts/features/attribution-factor-analysis/attribution-bar-chart-enums';
import { PerformancePeriodicity } from 'SecuritiesApp/ts/interfaces/attribution.interface';
import { getBasicFormatted, PERCENT } from 'Angular/utils/number_formatter';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../charts/static/charts/ts/features/bar-chart/bar-chart.component";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
const _c0 = a0 => ({ "chart-control-item": true, "current": a0 });
const _forTrack0 = ($index, $item) => $item.value;
const _forTrack1 = ($index, $item) => $item.name;
function AttributionFactorBarChartComponent_For_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 8)(1, "a", 23);
    i0.ɵɵlistener("click", function AttributionFactorBarChartComponent_For_10_Template_a_click_1_listener() { const periodicityOption_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.updatePeriodicityHandler.emit(periodicityOption_r4.value)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const periodicityOption_r4 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, periodicityOption_r4.value === ctx_r4.performancePeriodicity));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", periodicityOption_r4.label, " ");
} }
function AttributionFactorBarChartComponent_For_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ɵ$index_35_r7 = ctx.$index;
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("chart-legend-item-title bullet-", ɵ$index_35_r7 + 1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r6.name);
} }
function AttributionFactorBarChartComponent_For_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(4, "td", 24)(5, "td", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const ɵ$index_77_r9 = ctx.$index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("chart-legend-item-title bullet-", ɵ$index_77_r9 + 1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r8.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r4.formatPercentage(ctx_r4.attributionBarChartData.coefficients[ɵ$index_77_r9], true));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r4.attributionBarChartData.cssClasses[ɵ$index_77_r9]);
    i0.ɵɵproperty("textContent", ctx_r4.formatPercentage(item_r8.data[0]));
} }
export class AttributionFactorBarChartComponent {
    constructor() {
        this.updatePeriodicityHandler = new EventEmitter();
        this.ATTRIBUTION_MODE_LABELS = ATTRIBUTION_MODE_LABELS;
    }
    formatPercentage(value, removePercent = false) {
        if (value == null)
            return '--';
        const formatted = getBasicFormatted(value, PERCENT, 2);
        return removePercent ? formatted.replace('%', '').trim() : formatted;
    }
}
AttributionFactorBarChartComponent.ɵfac = function AttributionFactorBarChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionFactorBarChartComponent)(); };
AttributionFactorBarChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionFactorBarChartComponent, selectors: [["ycn-attribution-factor-bar-chart"]], inputs: { selectedAttribution: "selectedAttribution", attributionBarChartData: "attributionBarChartData", performancePeriodicity: "performancePeriodicity", periodicityOptions: "periodicityOptions" }, outputs: { updatePeriodicityHandler: "updatePeriodicityHandler" }, standalone: false, decls: 43, vars: 2, consts: [["helpModal", ""], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "help-toggler", 3, "click"], [1, "panel-actions"], [1, "panel-action"], [1, "chart-control", "chart-control-compact", "border-0"], [3, "ngClass"], [1, "panel-content"], [1, "chart-cover"], [1, "chart-interactive"], [1, "chart-item"], [1, "chart-options"], [1, "chart-legend"], [1, "chart-legend-item"], [1, "row"], [1, "row-12", "col-md-7"], [1, "chart-wrap"], [1, "chart-canvas", 2, "height", "400px"], [3, "chartData"], [1, "row-12", "col-md-5"], [1, "table"], ["href", "javascript:void(0)", 1, "chart-control-link", 3, "click"], [3, "textContent"]], template: function AttributionFactorBarChartComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "h3", 3);
        i0.ɵɵtext(3);
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵlistener("click", function AttributionFactorBarChartComponent_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(42); return i0.ɵɵresetView(helpModal_r2.openModal("attribution_factor_bar_chart")); });
        i0.ɵɵtext(5, " (?) ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 5)(7, "div", 6)(8, "ul", 7);
        i0.ɵɵrepeaterCreate(9, AttributionFactorBarChartComponent_For_10_Template, 3, 4, "li", 8, _forTrack0);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(11, "div", 9)(12, "div", 10)(13, "div", 11)(14, "div", 12)(15, "div", 13)(16, "div", 14);
        i0.ɵɵrepeaterCreate(17, AttributionFactorBarChartComponent_For_18_Template, 3, 4, "div", 15, _forTrack1);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(19, "div", 16)(20, "div", 17)(21, "div", 11)(22, "div", 12)(23, "div", 18)(24, "div", 19);
        i0.ɵɵelement(25, "ycn-bar-chart", 20);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(26, "div", 21)(27, "table", 22)(28, "thead")(29, "tr")(30, "th");
        i0.ɵɵtext(31, "Factor");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "th");
        i0.ɵɵtext(33, " Coefficients\u00A0 ");
        i0.ɵɵelementStart(34, "span", 4);
        i0.ɵɵlistener("click", function AttributionFactorBarChartComponent_Template_span_click_34_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(42); return i0.ɵɵresetView(helpModal_r2.openModal("attribution_factor_bar_chart_coefficients")); });
        i0.ɵɵtext(35, " (?) ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(36, "th");
        i0.ɵɵtext(37, "Factor Attribution");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(38, "tbody");
        i0.ɵɵrepeaterCreate(39, AttributionFactorBarChartComponent_For_40_Template, 6, 8, "tr", null, _forTrack1);
        i0.ɵɵelementEnd()()()()()()()()();
        i0.ɵɵelement(41, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" Factor ", ctx.ATTRIBUTION_MODE_LABELS[ctx.selectedAttribution], " Attribution Bar Chart\u00A0 ");
        i0.ɵɵadvance(6);
        i0.ɵɵrepeater(ctx.periodicityOptions);
        i0.ɵɵadvance(8);
        i0.ɵɵrepeater(ctx.attributionBarChartData.barChartData);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("chartData", ctx.attributionBarChartData.barChartData);
        i0.ɵɵadvance(14);
        i0.ɵɵrepeater(ctx.attributionBarChartData.barChartData);
    } }, dependencies: [i1.BarChartComponent, i2.NgClass, i3.HelpModalComponent], encapsulation: 2 });
